import styled from 'styled-components';

const TabBarOptionsWrapper = styled.div`
  flex: 1;
  justify-content: flex-end;
`;

export default TabBarOptionsWrapper;



// WEBPACK FOOTER //
// ./components/TabBar/TabBarOptionsWrapper.js